<div *ngIf="RoleId=='1' || RoleId=='2'" class='center'>
    <div class="arrowTabs" style="width : 100% !important;">
        <a class="active" style="cursor: default !important;">Step 1: Select Training Method</a>
        <a style="cursor: default !important;">Step 2 : Upload Supporting Files</a>
        <a style="cursor: default !important;">Step 3 : Pre-process and Train the System</a>

    </div>
</div>
<br /><br />

<div *ngIf="RoleId=='1' || RoleId=='2'" class="col-lg-12">

    <div class="card" style="width:49%;float:left;height:500px;">
        <!-- Alert for selecting sector and model -->
        <p class="alert alert-danger" id="successMessage" *ngIf="result.TrainError != null">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {{result.TrainError}}
        </p>
        <!--Alert  -->

        <h3 class="heading2" style="text-align:center;">Train with existing model</h3>
        <br><br>
        <ol style="margin-left:40px;font-size:16px !important;">
            <li>Select an existing model</li>
            <li>Add more excel files, if any</li>
            <li>Start training</li>
        </ol>
        <br><br /><br><br>
        <!-- <div class='center' *ngIf="Status != 'PROCESSED'">
            <a (click)="step2()">
                <button type="button" class="btn btn-lg btn-primary buttonStyle">
                    Train with existing model
                </button>
            </a>
        </div> -->
        <div class="row">
            <div class="col-xs-1"></div>
            <div class="col-xs-5">
                <a (click)="step2()">
                    <button type="button" class="btn btn-lg btn-primary buttonStyle">
                        Train with existing model
                    </button>
                </a>
            </div>
            <div class="col-xs-6">
                <a (click)="step2UploadTrainxls()">
                    <button type="button" class="btn btn-lg btn-primary buttonStyle">
                        Train existing model with train.xlsx
                    </button>
                </a>
            </div>
        </div>

        <!-- <div class="row" style="text-align: center; margin-right: 20px;margin-left: 20px;"
            *ngIf="Status == 'PROCESSED'">
            <div class="col-xs-6">
                <button routerLink="/Train/Step2" id="preprocess" type="submit"
                    class="btn btn-lg btn-primary buttonStyle">Pre-Process</button>
                <br />
            </div>
            <div class="col-xs-6">
                <button routerLink="/Train/Step3" id="train" type="submit" class="btn btn-lg btn-primary buttonStyle">Go
                    to Training</button>
                <br />
            </div>
        </div> -->
        <br>
        <br>
        <div style="font-size:16px !important;margin:0px 60px 40px 60px !important;color:#646464 !important;">
            <h5 id="viewVal" style="font-weight:normal;">MODEL STATUS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
                <span style="font-weight:normal !important;">&nbsp;{{ModelStatus}}</span>
            </h5>

            <h5 style="font-weight:normal;">ERROR MESSAGE&nbsp;&nbsp;:
                <span style="font-weight:normal !important;">&nbsp;{{ErrorMessage}}</span>
            </h5>
        </div>
    </div>

    <div class="card" style="width:49%;float:right;height:500px;">
        <!-- Alert for selecting sector and model -->
        <p class="alert alert-danger" id="successMessage" *ngIf="result.Train2Error != null">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {{result.Train2Error}}
        </p>
        <!--Alert  -->

        <h3 class="heading2" style="text-align:center;">Train with new data</h3>
        <br><br>
        <ol style="margin-left:40px;font-size:16px !important;">
            <li>Upload Excel files</li>
            <li>Select Excel columns to be considered</li>
            <li>Start training</li>
        </ol>
        <br><br /><br><br>
        <div class='center'><a (click)="step2new()">
                <button type="button" class="btn btn-lg btn-primary buttonStyle">Train with new data</button></a></div>
    </div>
</div>